import { DriverWorkType } from "@api/graphql/generated/generated-types";
import { DispatchCandidateSortingType } from "@src/shipments/types";
import { DriverDispatchCandidate } from "@src/shipments/utils/makeDispatchCandidateViews";

export type DriverGroup = {
  onlineRegular: DriverDispatchCandidate[];
  offlineRegular: DriverDispatchCandidate[];
  specialized: DriverDispatchCandidate[];
};

export const sortAndGroupDrivers = (
  drivers: DriverDispatchCandidate[],
  sorting: DispatchCandidateSortingType
): DriverGroup => {
  const getSortFunction = (sorting: DispatchCandidateSortingType) => {
    if (sorting === DispatchCandidateSortingType.LEAST_TASKS) {
      return (a: DriverDispatchCandidate, b: DriverDispatchCandidate) => {
        const aTasksLength = a.driver?.tasks?.length || 0;
        const bTasksLength = b.driver?.tasks?.length || 0;

        if (aTasksLength === bTasksLength) {
          return (a.driver?.firstName || "").localeCompare(b.driver?.firstName || "");
        }
        return aTasksLength - bTasksLength;
      };
    }

    return (a: DriverDispatchCandidate, b: DriverDispatchCandidate) => {
      return (a.driver?.firstName || "").localeCompare(b.driver?.firstName || "");
    };
  };

  const sortFunction = getSortFunction(sorting);

  const onlineRegular = drivers
    .filter((candidate) => candidate.driver?.workType === DriverWorkType.Regular && candidate.driver?.isActive)
    .sort(sortFunction);

  const offlineRegular = drivers
    .filter((candidate) => candidate.driver?.workType === DriverWorkType.Regular && !candidate.driver?.isActive)
    .sort(sortFunction);

  const specialized = drivers
    .filter((candidate) => candidate.driver?.workType === DriverWorkType.Specialized)
    .sort(sortFunction);

  return { onlineRegular, offlineRegular, specialized };
};
